import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Crown, Store, Check, Zap } from 'lucide-react';

const UpgradeModal = ({ open, onClose, feature = 'store_export' }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/subscription');
  };

  const content = {
    store_export: {
      title: "You're ready to shop!",
      description: "Your grocery list is ready. Upgrade to export directly to Instacart, Amazon Fresh, or Walmart.",
      icon: Store,
      benefits: [
        "Export to any store instantly",
        "Shopping mode helper",
        "Unlimited exports",
        "Save hours every week"
      ]
    },
    meal_planner: {
      title: "Plan your perfect week",
      description: "You've used your free trial week. Upgrade to plan unlimited meals.",
      icon: Zap,
      benefits: [
        "Unlimited meal planning",
        "Auto-generate grocery lists",
        "Drag & drop calendar",
        "Save your favorite plans"
      ]
    }
  };

  const { title, description, icon: Icon, benefits } = content[feature] || content.store_export;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
            <Icon className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-center text-2xl font-['Playfair_Display']">
            {title}
          </DialogTitle>
          <DialogDescription className="text-center">
            {description}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <ul className="space-y-3">
            {benefits.map((benefit, i) => (
              <li key={i} className="flex items-center gap-3">
                <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center">
                  <Check className="h-3 w-3 text-green-600" />
                </div>
                <span className="text-sm">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-3">
          <Button onClick={handleUpgrade} className="w-full h-12" data-testid="modal-upgrade-btn">
            <Crown className="h-4 w-4 mr-2" />
            Upgrade to Pro — $7/mo
          </Button>
          <Button variant="ghost" onClick={onClose} className="w-full">
            Maybe later
          </Button>
        </div>

        <p className="text-xs text-center text-muted-foreground">
          Cancel anytime. 100% satisfaction guaranteed.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeModal;
